import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { BookingDetails } from '../../types';
import BookingCodeEntry from './BookingCodeEntry';

interface SecureTokenHandlerProps {
  onAuthSuccess: (
    booking: BookingDetails, 
    method: 'booking_code' | 'mobile_verification' | 'secure_token',
    additionalData?: {
      isCheckedIn?: boolean;
      checkInStatus?: string;
      canAccessServices?: boolean;
    }
  ) => void;
}

const SecureTokenHandler: React.FC<SecureTokenHandlerProps> = ({ onAuthSuccess }) => {
  const { token } = useParams<{ token: string }>();

  // Determine if this is a secure token or a booking code
  const isSecureToken = (tokenStr: string): boolean => {
    // Secure tokens are much longer and contain colons and complex base64 data
    // Booking codes are typically short alphanumeric strings
    const isToken = tokenStr.length > 50 && tokenStr.includes(':');
    return isToken;
  };
  if (!token) {
    return <BookingCodeEntry onAuthSuccess={onAuthSuccess} />;
  }

  if (isSecureToken(token)) {
    // This is a secure token, handle it as such
    return <BookingCodeEntry onAuthSuccess={onAuthSuccess} isSecureToken={true} />;
  } else {
    // This is a regular booking code, handle it normally
    return <BookingCodeEntry onAuthSuccess={onAuthSuccess} />;
  }
};

export default SecureTokenHandler;